import { BabyStepCard, Modal } from "@aph/ui-lib-humanx";
import { useState } from "react";
import { JourneyItem } from "@/components/PageHome/api/interface";
import { STYLE_TYPE } from "@/components/PageHome/interfaces";
import OnboardingFlow from "@/components/PageHome/components/OnboardingSection/Modals/OnboardingFlow";
import onboardinFlowStyles from "@/components/PageHome/components/OnboardingSection/Onboarding.module.scss";
import currentFlowSelector from "@/components/PageHome/redux/selectors/currentFlow";
import { clearFlowData, setCurrentFlow } from "@/components/PageHome/redux/slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setIsOpenOnboardingSteps } from "@/components/ProfileSideDrawer/redux/slice";
import OnboardingStepsModalState from "@/components/ProfileSideDrawer/redux/selectors/onboardingStepsModalState";
import OnboardingJourneyStepsSelector from "@/components/ProfileSideDrawer/redux/selectors/onboardingJourneyStepsSelector";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { getPlainTexts } from "@/helpers";
import { NON_ONBOARDED_STATUS } from "@/helpers/constants";
import refererSelector from "@/redux/slice/global/selectors/refererSelector";
import styles from "./OnboardingStepsModal.module.scss";

const OnboardingStepsModal = () => {
  const [isFlowOpen, setIsFlowOpen] = useState<boolean>(false);
  const currentFlow = useAppSelector(currentFlowSelector);
  const isOpenOnboardingSteps = useAppSelector(OnboardingStepsModalState);
  const Journey = useAppSelector(OnboardingJourneyStepsSelector);
  const navSrcSelector = useAppSelector(refererSelector);
  const dispatch = useAppDispatch();

  return (
    <>
      <Modal
        backdropClose
        mobileBottomAlign
        titleAlign="center"
        open={isOpenOnboardingSteps}
        handleOpen={(): void => {
          dispatch(setIsOpenOnboardingSteps(false));
        }}
        isHXModal={true}
        modalboxClass={styles.modalboxClass}
        modalContentClass={styles.modalContentClass}
      >
        <>
          <h5 className={`${onboardinFlowStyles.title} ${styles.title}`}>
            Get more from <strong>Momverse</strong>
          </h5>
          <div className={`${onboardinFlowStyles.description} ${styles.description}`}>
            Choose your journey for a more personalised experience
          </div>
          {Journey?.length > 0 && (
            <div className={`${onboardinFlowStyles.cardsWrapper} ${styles.cardsWrapper}`}>
              {Journey.map((item: JourneyItem, index) => {
                const backgroundStyle: STYLE_TYPE = Object.values(STYLE_TYPE)[(index % 4) + 1];

                return (
                  <div key={item.id} className={onboardinFlowStyles.card}>
                    <BabyStepCard
                      className={`${onboardinFlowStyles.babyCard} ${styles.babyCard}`}
                      titleText={item.Title}
                      backgroundIconStyle={backgroundStyle}
                      onClick={(): void => {
                        if (currentFlow !== item.Type) {
                          dispatch(clearFlowData());
                        }

                        assetClickedEvent({
                          asset_name: "Onboarding Flow Card",
                          asset_display_text: getPlainTexts(item.Title),
                          asset_position: 1,
                          asset_element_position: index + 1,
                          momverse_stage: NON_ONBOARDED_STATUS,
                          nav_src: navSrcSelector,
                        });

                        dispatch(setCurrentFlow(item.Type));
                        setIsFlowOpen(true);
                        dispatch(setIsOpenOnboardingSteps(false));
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </>
      </Modal>
      <OnboardingFlow isOpen={isFlowOpen} currentFlow={currentFlow} onClose={() => setIsFlowOpen(false)} />
    </>
  );
};

export default OnboardingStepsModal;
